export default "__VITE_ASSET__vtWy24Rz__"